import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InfoMessage from "src/shared/components/InfoMessage";
import PaymentTabs from "src/shared/components/PaymentTabs";
import { MessageVariant } from "src/shared/enums/messageTypes/messageTypes";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "src/shared/context/useAuth";
import { enqueueSnackbar } from "notistack";

export default function TimeRenewalNamePurchaseApp() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { userHomePath } = useAuth();

  const { appId } = useParams();
  const location = useLocation();

  if (!location.state.appCost) {
    navigate(userHomePath);
    enqueueSnackbar(
      t("Δεν ήταν δυνατή η εύρεση του κόστους της προδέσμευσης"),
      { variant: "error" },
    );
    return;
  }

  useEffect(() => {
    const currentUrl = window.location.href;
    window.history.pushState({ _override: true }, "", currentUrl);

    const handlePopState = () => {
      navigate(userHomePath, { replace: true });
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        justifyContent: "center",
        maxWidth: { xs: "90vw", md: "80vw" },
        mx: "auto",
      }}
    >
      <InfoMessage
        message={t(
          "Μπορείτε να ανανεώσετε το χρόνο της Επωνυμίας ή του Διακριτικού Τίτλου που έχετε προδεσμεύσει μόνο μία φορά. Η δυνατότητα αυτή σας δίνεται μόνο εντός του διάστηματος των δύο μηνών από τη στιγμή που κάνατε την προδέσμευση έως ότου αυτή λήξει.",
        )}
        variant={MessageVariant.Info}
      />
      <h4>
        {t(
          "Οθόνη ανανέωσης χρόνου προδέσμευσης Επωνυμίας / Διακριτικού Τίτλου",
        )}
      </h4>
      <Typography>
        {t(
          "Η ανανέωση χρόνου προδέσμευσης Επωνυμίας ή Διακριτικού Τίτλου έχει κόστος (30.00 €) το οποίο θα πρέπει να εξοφλήσετε με χρήση πιστωτικής / χρεωστικής / prepaid κάρτας.",
        )}
      </Typography>
      <Typography>
        {t(
          "Για να ολοκληρωθεί η ανανέωση του χρόνου προδέσμευσης Επωνυμίας / Διακριτικού Τίτλου θα πρέπει πρώτα να πληρώσετε το αντίστοιχο τέλος με την κάρτα σας.",
        )}
      </Typography>
      <Button
        onClick={() => {
          navigate("/namePurchase/activePurchases");
        }}
      >
        {t("Θα κάνω την πληρωμή αργότερα. Μετάβαση στις προδεσμεύσεις μου")}
      </Button>
      <PaymentTabs
        appId={appId}
        mode="namePurchaseApplication"
        amount={location?.state?.appCost}
      />
    </Box>
  );
}
